
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "WsrTableListItem2558417618",
      {"classes":{"root":"WsrTableListItem2558417618__root","contentContainer":"WsrTableListItem2558417618__contentContainer"},"vars":{"containerOutline":"--containerOutline"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  